module.exports = __webpack_public_path__ + "img/chateau_vecquee_dejeuner.045e63d2.jpg";